module.exports = __webpack_public_path__ + "img/mc.78528abe.svg";